// Shared display-layer timezone helper (Iter 255).
//
// Many collections store timestamps timezone-NAIVE (e.g.
// "2026-09-01T15:52:48.693000", no trailing Z) even though the value is
// UTC. JS `new Date()` parses a naive string as LOCAL time, which skews
// display by the viewer's offset. These helpers normalize naive values to
// UTC first, then render in America/New_York (EST/EDT, DST automatic).
//
// Display-only. Never used for storage/writes.

const AWARE_RE = /([zZ]|[+-]\d{2}:?\d{2})$/;
const ISO_RE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;
const TZ = "America/New_York";

// Parse an ISO-ish value into a Date, treating naive strings as UTC.
export function toUtcDate(iso) {
  if (!iso) return null;
  let s = String(iso);
  if (ISO_RE.test(s) && !AWARE_RE.test(s)) s += "Z";
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

// Returns { d, t } — date ("Sep 1, 2026") and time ("11:52 AM EDT").
export function formatEST(iso) {
  const dt = toUtcDate(iso);
  if (!dt) return { d: "—", t: "" };
  return {
    d: dt.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric", timeZone: TZ }),
    t: dt.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit", timeZone: TZ, timeZoneName: "short" }),
  };
}

// Single-string convenience: "Sep 1, 2026 · 11:52 AM EDT" (or a custom sep).
export function formatESTString(iso, sep = " · ") {
  const { d, t } = formatEST(iso);
  return t ? `${d}${sep}${t}` : d;
}
